import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "symbolField", "pointsField", "icon",
    "labelLeftField", "labelRightField",
    "labelsContainer", "labelLeftPreview", "labelRightPreview"
  ];

  update() {
    const symbol = this._symbolValue();
    const points = this._pointsValue();

    this.iconTargets.forEach((icon) => {
      const matches = icon.dataset.symbol === symbol && Number(icon.dataset.index) <= points;

      icon.classList.toggle('hidden', !matches);
    });

    this._updateLabels();
  }

  _symbolValue() {
    return this.symbolFieldTarget.querySelector('input[type="hidden"]')?.value;
  }

  _pointsValue() {
    return Number(this.pointsFieldTarget.querySelector('input[type="hidden"]')?.value);
  }

  _updateLabels() {
    const labelLeft = this.labelLeftFieldTarget.value;
    const labelRight = this.labelRightFieldTarget.value;
    const labelsPresent = labelLeft.trim() !== '' || labelRight.trim() !== '';

    this.labelLeftPreviewTarget.textContent = labelLeft;
    this.labelRightPreviewTarget.textContent = labelRight;
    this.labelsContainerTarget.classList.toggle('hidden', !labelsPresent);
  }
}
